<template>
  <div :class="ownedLandClasses">
    <FlexWrap>
      <div class="container">
        <p class="qa">{{ qa }}</p>
        <p class="explanation-text" v-if="panel === 'begin'">ter indicatie: een tennisbaan is 200 vierkante meter</p>
        <div class="character-pane">
          <svg
            class="pane"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 240 120.18"
            :style="paneSize"
          >
            <path
              :fill="fillColor"
              d="M120.85 0L0 59.59l120.85 60.59L240 59.59 120.85 0z"
            />
          </svg>
          <img
            :src="src"
            draggable="false"
            alt=""
            class="character"
            :style="charStyles"
            width="70"
            height="230"
          />
        </div>
        <template v-if="panel === 'begin'">
          <input
            type="range"
            min="100"
            :max="max"
            step="10"
            v-model="value"
            class="range"
          />
          <p class="meterage">{{ plusminus }}{{ value }}m2</p>
        </template>
        <p
          v-else-if="panel !== 'begin'"
          class="text"
        >{{ endText }}</p>
        <footer class="footer">
          <template v-if="panel === 'begin'">
            <Button
              class="button"
              @click.native="next"
            >check</Button>
          </template>
          <ScrollChevron
            scrollTo="#after-owned-land"
            :conditionals="panel !== 'begin'"
          />
        </footer>
      </div>
    </FlexWrap>
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'
import { trekInteractive } from '@/utils/trek'
import Button from '@/components/Button'
import { ScrollChevron, FlexWrap } from '@/components/chapter'

export default {
  name: 'OwnedLand',
  data () {
    return {
      panel: 'begin',
      qa: 'Hoeveel vierkante meter grond bezit je?',
      endText: 'Helaas, je mag niet stemmen. Nog altijd had geen enkele vrouw stemrecht.',
      fillColor: '#D8D8D5',
      backgroundColor: '#32BEC8',
      value: 430,
      max: 1500,
      filename: 'fy'
    }
  },
  watch: {
    panel () {
      switch (this.panel) {
        case 'begin':
          this.qa = 'Hoeveel vierkante meter grond bezit je?'
          this.fillColor = '#ff6e6e'
          break
        case 'success':
          this.qa = 'Gefeliciteerd!'
          this.fillColor = '#EBEBE6'
          break
        case 'fail':
          this.qa = 'Helaas...'
          this.fillColor = '#32BEC8'
          this.backgroundColor = '#E61E14'
          break
      }
    }
  },
  components: {
    Button,
    ScrollChevron,
    FlexWrap
  },
  mounted () {
    EventBus.$on('characterChoice', filename => {
      this.filename = filename
    })
  },
  methods: {
    next () {
      trekInteractive('1850-owned-land')
      const hasEnoughGround = this.value > 1441
      this.panel = (this.filename === 'mo' && hasEnoughGround) ? 'success' : 'fail'

      if (this.filename === 'my') {
        this.endText = hasEnoughGround ? 'Grond of niet, dat maakt voor jou helaas niks uit. Om te mogen stemmen, moest je namelijk nog steeds minimaal 23 jaar zijn.' : 'Helaas, je mag niet stemmen. Naast dat je niet genoeg grond bezit, moest je ook nog steeds ouder dan 23 jaar zijn.'
      }

      if (this.filename === 'mo') {
        this.endText = hasEnoughGround ? 'Gefeliciteerd, jij hoort bij de 10 procent van de mannelijke 23+’ers die in 1850 naar de stembus mocht. Over je grond betaalde je namelijk een speciale belasting, en die belasting speelde een belangrijke rol in het nieuwe kiessysteem van 1850.' : 'Helaas, je hebt niet genoeg grond. Daarover betaalde je namelijk belasting, en die belasting speelde een belangrijke rol in het nieuwe kiessysteem van 1850.'
      }

      if (['fy', 'fo'].includes(this.filename)) {
        this.endText = 'Helaas, je mag niet stemmen. Nog altijd had geen enkele vrouw stemrecht.'
      }

      EventBus.$emit('groundSize', hasEnoughGround)
    }
  },
  computed: {
    ownedLandClasses () {
      return {
        'owned-land': true,
        'fail-land': this.panel === 'fail'
      }
    },
    paneSize () {
      return {
        'transform': `translateX(-50%) scale(${(this.value / this.max)})`
      }
    },
    plusminus () {
      if (+this.value === 1500) {
        return '>'
      }
      if (+this.value === 100) {
        return '<'
      }
      return ''
    },
    charStyles () {
      const sum = 1 - (this.value / this.max)
      const scale = sum > 0.05 ? sum : 0.05
      return {
        'transform': `scale(${scale})`
      }
    },
    src () {
      return require(`@/assets/images/char-${this.filename}.svg`)
    }
  }
}
</script>

<style lang="scss" scoped>
.owned-land {
  background-color: $c-blue;
  text-align: center;
  transition: background-color 1s ease;
}

.fail-land {
  background-color: $c-red;
}

.text {
  color: white;
  text-align: left;
}

.explanation-text {
  color: white;
  text-align: center;
  margin-top: 0.5em;
}

.qa {
  color: white;
  font-size: 26px;
  line-height: $lh-heading;
  font-weight: $fw-bold;
  text-align: center;
}

.character-pane {
  position: relative;
  text-align: center;
  height: 350px;
  font-size: 0;
}

.pane {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  will-change: transform;
  z-index: 1;
  opacity: 0.8;
  width: 456px;
  height: 228px;
  bottom: 63px;
  transform-origin: 50% 100%;
  margin: 0 auto;
}

.character {
  margin: 0 auto;
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 63px;
  z-index: 2;
}

.footer {
  position: relative;
  height: 120px;
  text-align: center;
}

$range-active-color: $c-red;
$range-button-color: white;
$range-height: 6px;
$range-button-height: 26px;

.range {
  -webkit-appearance: none;
  width: 100%;
  margin: 1em 0;
  background-color: transparent;
  border-radius: 3px;

  &:focus {
    outline: 0;
  }

  &::-webkit-slider-runnable-track {
    width: 100%;
    height: $range-height;
    cursor: pointer;
    background: $c-dark;
    border-radius: 3px;
    box-shadow: none;
    border: none;
  }

  &::-webkit-slider-thumb {
    border: none;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.16);
    height: $range-button-height;
    width: $range-button-height;
    border-radius: $range-button-height / 2;
    background: $range-button-color;
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: 0 - ($range-button-height / 2) + ($range-height / 2);
  }

  &::-moz-range-progress {
    background-color: $c-red;
    height: $range-height;
    border-radius: 3px;
  }

  &::-moz-range-track {
    width: 100%;
    height: $range-height;
    cursor: pointer;
    background: $c-dark;
    border-radius: 3px;
  }

  &::-moz-range-thumb {
    height: $range-button-height;
    width: $range-button-height;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.16);
    border-radius: $range-button-height / 2;
    background: $range-button-color;
    cursor: pointer;
  }

  &::-ms-track {
    width: 100%;
    height: 6px;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    color: transparent;
  }

  &::-ms-fill-lower {
    background: $c-red;
    border-radius: 3px;
  }

  &::-ms-fill-upper {
    background: $c-dark;
    border-radius: 3px;
  }

  &::-ms-thumb {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.16);
    height: $range-button-height;
    width: $range-button-height;
    border-radius: $range-button-height / 2;
    background: $range-button-color;
    cursor: pointer;
  }
}

.meterage {
  font-size: 26px;
  font-weight: $fw-bold;
  text-align: center;
}
</style>
